<template>
<div>
<modal-dialog
	:modal-visible="visible"
	title="Edit Assembly"
	confirm-button-text="Save"
	v-on:confirm="confirm"
	v-on:closeModal="$emit('closeModal')">

	<template v-if="record.unit_type != 'Unit'">
		<field :label="'Length ('+linearUnit+')'"
			col-class="col-md-4"
			:params="{type:'number',step:0.05}"
			v-model="payload.linear_qty">

			<p class="text-muted">Length contained in each assembly</p>

		</field>

		<field label="# Segments"
			col-class="col-md-4"
			:params="{type:'number',step:1}"
			v-model="payload.num_segments">

			<p class="text-muted">Number of segments in each assembly</p>
		</field>
	</template>

	<div class="row mb-2">
		<div class="col-md-4"></div>
		<div class="col-md-8">
			<info-box label="Base Price Per Assembly" 
				:value="assemblyBasePrice.toCurrency()">
			</info-box>
		</div>
	</div>

	<field label="Qty"
		col-class="col-md-4"
		:params="{type:'number',step:0.05}"
		v-model="payload.qty">
		<p class="text-muted">Total number of complete assemblies</p>
	</field>

	<field label="Price Adjustment"
		col-class="col-md-4"
		:params="{type:'number',step:0.001}"
		v-model="payload.priceAdjustment">
	</field>

	<field label="Markup"
		col-class="col-md-4"
		:params="{type:'number',step:0.001}"
		v-model="payload.markup">
	</field>

	<div class="row mb-2">
		<div class="col-md-4"></div>
		<div class="col-md-8">
			<info-box label="Total Price" :value="totalPrice.toCurrency()"></info-box>
		</div>
	</div>

	<button class="btn btn-dark btn-sm" type="button" v-on:click="disconnectAssembly">
		Disconnect Materials...
	</button>

	<template slot="footer">

		<button class="btn btn-light btn-sm" type="button" v-on:click="viewAssemblyDetails">
			View Assembly Details...
		</button>

	</template>

</modal-dialog>

<modal-dialog :modal-visible="disconnectAssemblyModal.visible"
	title="Disconnect Materials from Assembly"
	confirm-button-text="Confirm"
	v-on:closeModal="disconnectAssemblyModal.visible = false"
	v-on:confirm="confirmDisconnectAssembly">
	Are you sure you want to disconnect the materials from this assembly? This will allow you to edit materials individually, but the materials will no longer be tracked by the parent assembly.
</modal-dialog>
</div>
</template>

<script>
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import InfoBox from "@/components/InfoBox"

import InvoiceMaterialMixins from "@/mixins/InvoiceMaterialMixins.js"

export default {
	name: "BillingDocumentAssemblyEditModal",
	components: {
		Field,
		ModalDialog,
		InfoBox
	},
	mixins: [InvoiceMaterialMixins],
	props: [
		"visible",
		"record"
	],
	data() {
		return {
			payload: {},
			fields: {
				linear_qty: 1,
				qty: 1,
				num_segments: 1,
				priceAdjustment: 1,
				markup: 1,
				id: null
			},
			disconnectAssemblyModal: {
				visible: false
			}
		}
	},
	watch: {
		record() {
			this.setPayload()
		}
	},
	computed: {
		assemblyBasePrice() {
			let as = this.cloneObj(this.payload)

			as.price_per_unit = this.record.price_per_unit
			as.price_per_segment = this.record.price_per_segment
			as.price_per_assembly = this.record.price_per_assembly

			if (as)
				return this.calcAssemblyBasePrice(as)

			return 0
		},
		totalPrice() {	
			let as = this.cloneObj(this.payload)

			as.price_per_unit = this.record.price_per_unit
			as.price_per_segment = this.record.price_per_segment
			as.price_per_assembly = this.record.price_per_assembly

			if (as)
				return this.calcAssemblyTotalPrice(as) * +this.payload.qty

			return 0
		},
		linearUnit() {
			if (this.record && "unit_type" in this.record)
				return this.record.unit_type

			return 0
		}
	},
	methods: {
		setPayload() {
			let vm = this
			if (this.record) {
				Object.keys(vm.fields).forEach(field => {
					if (field in vm.record)
						vm.$set(vm.payload,field,vm.record[field])
					else
						vm.$set(vm.payload,field,vm.fields[field])
				})
			}
		},
		viewAssemblyDetails() {
			this.$emit('viewAssemblyDetails')
		},
		disconnectAssembly() {
			this.disconnectAssemblyModal.visible = true
		},
		confirmDisconnectAssembly() {
			this.$emit("disconnectChildMaterials")
			this.disconnectAssemblyModal.visible = false
		},
		confirm() {
			this.$emit("confirm",this.payload)
		}
	},
	created() {
		this.setPayload()
	}
}
</script>